<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form
            action=""
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
        >
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <ckeditor
                        :editor="editor"
                        v-model="summary"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Crear
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            title: null,
            summary: null,
            contest_id: null,
            allerrors: {
                title: null,
                summary: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "bold",
                    "italic",
                    "underline",
                    "bulletedList",
                    "numberedList",
                ],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/faqs/show/" + me.model_id)
                .then(function (response) {
                    me.title = response.data.model.title;
                    me.summary = response.data.model.summary;
                    me.contest_id = response.data.model.contest_id;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            if (me.validForm()) {
                axios
                    .post(`/api/contests/faqs?contest_id=${me.parent_id}&key=${authUserId}`, {
                        summary: me.summary,
                        title: me.title,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.errors
                        ) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put("/api/contests/faqs/update/" + me.model_id, {
                        summary: me.summary,
                        title: me.title,
                        contest_id: me.contest_id,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 190) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 1000) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 1000 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                summary: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        if (this.model_id > 0) {
            this.getModel();
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
